<h1>My Agents</h1>
@defer (when agentsLoaded()) {
  <app-agent-table
    [showTableDetails]="true"
    [(gridData)]="gridView"
    [tableColumns]="[
    { field: 'name', title: 'Name', width: 300 },
    { field: 'description', title: 'Description' },
    { field: 'keywords', title: 'Keywords' },
    { field: 'ownerList', title: 'Owners', hidden: true },
    { field: 'userList', title: 'Users', hidden: true },
    { field: 'groupList', title: 'Groups', hidden: true },
    { field: 'sensitivityLabelList', title: 'Sensitivity Label', hidden: true },
    ]"/>
} @placeholder {
  <div class="loading-placeholder">Loading agents...</div>
}
